import { useEffect, useMemo, useRef, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { CREWS } from "../../game/data/crews";
import { REEL_ANIMATE, REEL_EXIT, REEL_INITIAL_BLUR, REEL_INITIAL_SHARP } from "./motionPresets";

const DELAYS = [35, 35, 40, 45, 50, 55, 65, 75, 90, 110, 135, 165];
const LANDING_EASE = [0.2, 1.4, 0.4, 1];

export const SpinReel = ({ target, onDone }) => {
  const [tick, setTick] = useState(0);
  const [label, setLabel] = useState(CREWS[0].name);
  const doneRef = useRef(onDone);
  doneRef.current = onDone;

  useEffect(() => {
    const timers = [];
    let t = 0;
    let prev = null;
    DELAYS.forEach((d, i) => {
      t += d;
      timers.push(
        setTimeout(() => {
          const last = i === DELAYS.length - 1;
          let next = target.name;
          if (!last) {
            const others = CREWS.filter((c) => c.name !== prev && c.id !== target.id);
            next = others[Math.floor(Math.random() * others.length)].name;
          }
          prev = next;
          setLabel(next);
          setTick(i + 1);
          if (last) timers.push(setTimeout(() => doneRef.current(), 380));
        }, t),
      );
    });
    return () => timers.forEach(clearTimeout);
  }, [target]);

  const speed = DELAYS[Math.min(tick, DELAYS.length - 1)] / 1000;
  const landed = tick === DELAYS.length;
  const transition = useMemo(
    () => ({ duration: Math.max(speed * 0.9, 0.03), ease: landed ? LANDING_EASE : "linear" }),
    [speed, landed],
  );

  return (
    <div className="reel-window" data-testid="spin-reel">
      <AnimatePresence initial={false} mode="popLayout">
        <motion.p
          key={tick}
          initial={landed ? REEL_INITIAL_SHARP : REEL_INITIAL_BLUR}
          animate={REEL_ANIMATE}
          exit={REEL_EXIT}
          transition={transition}
          className={`reel-label font-display ${landed ? "text-[#14233D] reel-landed" : "text-[#7433C1]"}`}
        >
          {label}
        </motion.p>
      </AnimatePresence>
    </div>
  );
};
